import "antd/es/statistic/style";
import _Statistic from "antd/es/statistic";
var _excluded = ["className", "dependField", "countDownSeconds", "sendOtp", "fireBaseId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useContext, useEffect } from 'react';
import Input from './input';
import formMethods from '../utils/form-methods';
import omit from 'omit.js';
import classNames from 'classnames';
import Typography from '../typography';
import Button from '../button';
import invariant from 'invariant';
import LocaleContext from '../locale/locale-context';

var Otp = function Otp(_ref) {
  var className = _ref.className,
      dependField = _ref.dependField,
      _ref$countDownSeconds = _ref.countDownSeconds,
      countDownSeconds = _ref$countDownSeconds === void 0 ? 60 : _ref$countDownSeconds,
      sendOtp = _ref.sendOtp,
      fireBaseId = _ref.fireBaseId,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      first = _useState2[0],
      setFirst = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      countDown = _useState4[0],
      setCountDown = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      ddl = _useState6[0],
      setDdl = _useState6[1];

  var form = typeof props.getFormInstance === 'function' ? props.getFormInstance() : null;
  invariant(form, 'Otp Input can only be used with Form.');
  invariant(typeof sendOtp === 'function', 'sendOtp should be a function');
  var dependValue = form.getFieldValue(dependField);
  useEffect(function () {
    setCountDown(false);
    setFirst(true);
  }, [dependValue]);

  var _useContext = useContext(LocaleContext),
      formatMessage = _useContext.formatMessage;

  var send = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return sendOtp(dependValue);

            case 2:
              setDdl(Date.now() + countDownSeconds * 1000);
              setCountDown(true);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function send() {
      return _ref2.apply(this, arguments);
    };
  }();

  var reset = function reset() {
    setCountDown(false);
    setFirst(false);
  };

  return _jsxs("div", {
    className: "igloo-otp",
    children: [!countDown && _jsx(Button, {
      type: "link",
      className: "igloo-otp-extra",
      disabled: !dependValue,
      onClick: send,
      id: fireBaseId,
      children: _jsx(Typography, {
        level: "h4",
        children: first ? formatMessage({
          id: 'Send OTP'
        }) : formatMessage({
          id: 'Resend OTP'
        })
      })
    }), countDown && _jsxs("div", {
      className: "igloo-otp-extra igloo-otp-count-down",
      children: [formatMessage({
        id: 'Resend in'
      }), " (", _jsx(_Statistic.Countdown, {
        className: "igloo-otp-count-down-inner",
        value: ddl,
        format: "s",
        onFinish: reset
      }), "s)"]
    }), _jsx(Input, _objectSpread(_objectSpread({}, omit(props, formMethods)), {}, {
      className: classNames(className)
    }))]
  });
};

Otp.formItemPropsHandler = function (config) {
  return {};
};

export default Otp;